import { render } from "./psiStore.vue?vue&type=template&id=dc6be56a"
import script from "./psiStore.vue?vue&type=script&lang=jsx"
export * from "./psiStore.vue?vue&type=script&lang=jsx"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__